<template>
  <div class="container reporte-ecp-container">
    <b-row>
      <b-container>
        <h3 class="text-center py-2">
          <b><i>{{ labels.title }}</i></b>
        </h3>

        <h5 class="text-center py-2">
          <!-- FILTROS -->
          <b-row class="mb-4 justify-content-center align-items-end text-lg">
            <b-col md="auto" class="text-center px-3">
              <label class="d-block fw-bold fs-4 mb-3"><b>{{ labels.reporte }}</b></label>
              <select v-model="selReporte" @change="f_actualiza_reporte()"
                class="form-control form-control-lg w-auto mx-auto fs-5" style="min-width: 200px;">
                <option value="">Seleccione...</option>
                <option v-for="reporte in reportes" :key="reporte.codigo" :value="reporte.codigo">
                  {{ reporte.codigo }} - {{ reporte.nombre }}
                </option>
              </select>
            </b-col>

            <b-col md="auto" class="text-center px-3">
              <label class="d-block fw-bold fs-4 mb-3">
                <b>{{ labels.vigencia }}</b>
              </label>
              <select v-model="selVigencia" @change="f_actualiza_vigencia()"
                class="form-control form-control-lg w-auto mx-auto fs-5" style="min-width: 200px;">
                <option value="">Seleccione...</option>
                <option v-for="vigencia in listVigencia" :key="vigencia.vigencia" :value="vigencia.vigencia">
                  {{ vigencia.vigencia }}
                </option>
              </select>
            </b-col>

            <b-col md="auto" class="text-center px-3">
              <label class="d-block fw-bold fs-4 mb-3">
                <b>{{ labels.grupo }}</b>
              </label>
              <select v-model="grupoId" @change="f_actualiza_grupo()"
                class="form-control form-control-lg w-auto mx-auto fs-5" style="min-width: 200px;">
                <option value="todos">Todos los grupos</option>
                <option v-for="grupo in listGrupos" :key="'grupo-' + grupo.id" :value="grupo.id">
                  {{ grupo.nombre }}
                </option>
              </select>
            </b-col>

            <b-col md="auto" class="text-center px-3">
              <label class="d-block fw-bold fs-4 mb-3">
                <b>{{ labels.company }}</b>
              </label>
              <select v-model="companyId" @change="f_actualiza_compania()"
                class="form-control form-control-lg w-auto mx-auto fs-5"
                style="min-width: 180px; max-width: 250px;">
                <option value="">Seleccione...</option>
                <option v-for="company in filteredCompanies" :key="company.id" :value="company.id">
                  {{ company.acronym ? company.acronym + ' ' : '' }}{{ company.nombre }}
                </option>
              </select>
            </b-col>
          </b-row>

          <!-- BOTÓN CONSULTAR -->
          <b-row class="mb-4 justify-content-center align-items-center">
            <b-col md="auto" class="text-center">
              <b-button variant="primary" @click="consulReporteECP()" :disabled="!isFormValid"
                class="btn-lg px-5 mx-2 fs-5">
                <b><i>{{ labels.consultar }}</i></b>
              </b-button>
            </b-col>
          </b-row>
        </h5>
      </b-container>
    </b-row>

    <!-- Zona de botones de agregar fila/columna (solo si showRowCol es true) -->
    <div class="row col-md-12 mt-4" v-if="showRowCol">
      <div class="col-md-1"></div>
      <div class="col-md-5">
        <md-button style="background-color: #2e507a; width: 35px; height: 35px;" class="md-fab md-primary" @click="newFila"
          :disabled="isVigenciaBloqueada">
          <md-icon>add</md-icon>
        </md-button>
      </div>
      <div class="col-md-5">
        <md-button style="background-color: #2e507a; width: 35px; height: 35px;" class="md-fab md-primary" @click="newColumna"
          :disabled="isVigenciaBloqueada">
          <md-icon>add</md-icon>
        </md-button>
      </div>
      <div class="col-md-1"></div>
    </div>

    <!-- Zona de visualización de filas y columnas -->
    <div class="row mt-3" v-if="showRowCol">
      <div class="col-md-1"></div>
      <div class="col-md-5">
        <div class="headNivUno">
          {{ labels.fila }}
        </div>
        <div class="bodyFila" v-if="listFila.length == 0">
          {{ labels.notRow }}
        </div>
        <div v-else>
          <div class="bodyFila" v-for="fila in listFila" :key="fila.id">
            {{ fila.fila }} . {{ fila.descripcion }}
          </div>
        </div>
      </div>
      <div class="col-md-5">
        <div class="headNivUno">{{ labels.columna }}</div>
        <div class="bodyColumna" v-if="listColumna.length == 0">
          {{ labels.notRow }}
        </div>
        <div v-else>
          <div class="bodyColumna" v-for="columna in listColumna" :key="columna.id">
            {{ columna.columna }} . {{ columna.descripcion }}
          </div>
        </div>
      </div>
      <div class="col-md-1"></div>
    </div>

    <!-- Botón de detalle -->
    <div class="row mt-5" v-if="showRowCol">
      <div class="col-md-12">
        <b-button @click="consultECP()" id="consult-btn">{{ labels.detail }}</b-button>
      </div>
    </div>

    <!-- Modales y componentes de detalle -->
    <NewFilaVue :showFila="showModFila" @closeModal="cierraModal" @reloadTblFila="recargaTblFila" />
    <NewColumna :showColumna="showModColumna" @closeModal="cierraModal" @reloadTblColumna="recargaTblColumna" />
    <EcpFilaColumna
      v-if="showListFilaCol"
      :vigCompSel="infoVigeCom"
      :consulDetallEcp="infoVigeCom"
      :readOnly="isVigenciaBloqueada"
    />
  </div>
</template>

<script>
import Balance from '../../services/BalanceNiif'
import PlanCuentas from '../../services/PlanCuentas'
import Company from '../../services/Company'
import EcpReporte from '../../services/EcpReporte'
import Grupo from '../../services/Grupo'
import NewFilaVue from './NewFila.vue'
import NewColumna from './NewColumna.vue'
import EcpFilaColumna from './EcpFilaColumna.vue'

export default {
  name: 'EcpReporte',
  components: {
    NewFilaVue,
    NewColumna,
    EcpFilaColumna
  },
  data: () => ({
    selVigencia: "",
    vigencia_anterior: '',
    companyId: "",
    compania_anterior: '',
    selReporte: '',
    codReporteAnterior: '',
    grupoId: 'todos',
    listGrupos: [],
    listVigencia: [],
    listCompany: [],
    filteredCompanies: [],
    companiaUsuario: [],
    reportes: [],
    showRowCol: false,
    listFila: [],
    listColumna: [],
    showModFila: false,
    showModColumna: false,
    showListFilaCol: false,
    infoVigeCom: {
      vigencia: "",
      companyId: "",
      compania: "",
      codReporte: ""
    }
  }),
  computed: {
    isVigenciaBloqueada() {
      return this.selVigencia ? !this.$store.getters.isPeriodoEnabled(this.selVigencia) : false
    },
    labels() {
      if (this.$store.state._language == "es-ES") {
        return {
          title: "Reporte ECP",
          reporte: "Reporte:",
          vigencia: "Vigencia:",
          grupo: "Grupo:",
          company: "Compañía:",
          consultar: "Consultar",
          fila: "FILA",
          columna: "COLUMNA",
          detail: "DETALLE",
          notRow: "No hay Registros"
        }
      } else {
        return {
          title: "ECP Report",
          reporte: "Report:",
          vigencia: "Validity:",
          grupo: "Group:",
          company: "Company:",
          consultar: "Consult",
          fila: "ROW",
          columna: "COLUMN",
          detail: "DETAIL",
          notRow: "There are not records"
        }
      }
    },
    isFormValid() {
      return this.selReporte && this.selVigencia && this.companyId
    }
  },
  methods: {
    f_actualiza_reporte() {
      if (this.codReporteAnterior != this.selReporte) {
        this.resetData()
        this.codReporteAnterior = this.selReporte
      }
    },
    f_actualiza_vigencia() {
      if (this.vigencia_anterior != this.selVigencia) {
        this.resetData()
        this.vigencia_anterior = this.selVigencia
      }
      if (this.isVigenciaBloqueada) {
        this.$toast.error('La vigencia seleccionada está deshabilitada para crear o editar.')
      }
    },
    f_actualiza_compania() {
      if (this.compania_anterior != this.companyId) {
        this.resetData()
        this.compania_anterior = this.companyId
      }
    },
    f_actualiza_grupo() {
      this.filtrarCompaniesPorGrupo()
      this.resetData()
      this.companyId = ""
    },
    resetData() {
      this.showRowCol = false
      this.showModFila = false
      this.showModColumna = false
      this.showListFilaCol = false
    },
    filtrarCompaniesPorGrupo() {
      this.companyId = ''
      this.resetData()

      if (this.grupoId === 'todos' || !this.grupoId) {
        this.filteredCompanies = [...this.listCompany]
      } else {
        const grupoIdStr = this.grupoId.toString()
        this.filteredCompanies = this.listCompany.filter(company => {
          if (!company.id_grupos) return false
          const gruposCompania = company.id_grupos.split(',').map(id => id.trim())
          return gruposCompania.includes(grupoIdStr)
        })
      }
    },
    consulReporteECP() {
      if (this.selVigencia != "" && this.companyId != "" && this.selReporte != "") {
        this.showRowCol = true
        this.infoVigeCom = {
          "vigencia": this.selVigencia,
          "companyId": this.companyId,
          "compania": this.companyId,
          "codReporte": this.selReporte
        }
      } else {
        this.$toast.error("Diligenciar los campos: reporte, vigencia y compañía")
      }
    },
    consultECP() {
      this.showListFilaCol = true
    },
    newFila() {
      if (this.isVigenciaBloqueada) {
        this.$toast.error('La vigencia seleccionada está deshabilitada para crear o editar.')
        return
      }
      this.showModFila = true
    },
    newColumna() {
      if (this.isVigenciaBloqueada) {
        this.$toast.error('La vigencia seleccionada está deshabilitada para crear o editar.')
        return
      }
      this.showModColumna = true
    },
    cierraModal(val) {
      this.showModFila = val
      this.showModColumna = val
    },
    recargaTblFila(val) {
      this.showModFila = val
      EcpReporte.getAllFila()
        .then((res) => {
          this.listFila = res.data.allFila
        })
        .catch((err) => {
          console.log(err.message)
          this.listFila = []
        })
    },
    recargaTblColumna(val) {
      this.showModColumna = val
      EcpReporte.getAllColumna()
        .then((res) => {
          this.listColumna = res.data.allColumn
        })
        .catch((err) => {
          console.log(err.message)
          this.listColumna = []
        })
    }
  },
  mounted() {
    Balance.leaCompaniaUsuario()
      .then((result) => {
        this.companiaUsuario = result.data.companiaUsuario
      })

    PlanCuentas.getVigenciaPlancuentas()
      .then((result) => {
        this.listVigencia = result.data.getVigencia
      })
      .catch((err) => {
        console.log(err)
      })

    Company.getAllCompanies()
      .then((result) => {
        this.listCompany = result.data.companies
        let v_companias = []
        result.data.companies.forEach((element) => {
          const v_usuario = this.companiaUsuario.find((r_usuario) =>
            r_usuario.id_usuario == this.$store.state.userId &&
            r_usuario.id_compania == element.id)
          if (this.$store.state.userRole == 1 || v_usuario) {
            v_companias.push(element)
          }
        })
        this.listCompany = v_companias
        this.filteredCompanies = [...v_companias]
      })
      .catch((err) => {
        console.log(err)
      })

    Balance.getReportes()
      .then((result) => {
        this.reportes = result.data.reportes
      })
      .catch(() => {
        this.error = true
      })

    Grupo.getAllGrupos()
      .then((result) => {
        this.listGrupos = result.data.grupos || []
      })
      .catch((err) => {
        console.log(err)
      })

    EcpReporte.getAllFila()
      .then((res) => {
        this.listFila = res.data.allFila
      })
      .catch((err) => {
        console.log(err.message)
        this.listFila = []
      })

    EcpReporte.getAllColumna()
      .then((res) => {
        this.listColumna = res.data.allColumn
      })
      .catch((err) => {
        console.log(err.message)
        this.listColumna = []
      })
  },
  watch: {
    selReporte(valNew) {
      this.infoVigeCom.codReporte = valNew
    },
    selVigencia(valNew) {
      this.infoVigeCom.vigencia = valNew
    },
    companyId(valNew) {
      this.infoVigeCom.companyId = valNew
    }
  }
}
</script>

<style scoped>
.reporte-ecp-container {
  margin-top: 20px;
}

.fs-5 {
  font-size: 1.25rem !important;
}

.fs-4 {
  font-size: 1.5rem !important;
  font-weight: 700 !important;
}


.mb-3 {
  margin-bottom: 1rem !important;
}

.form-control-lg {
  font-size: 1.25rem;
  padding: 0.5rem 1rem;
  height: auto;
  line-height: 1.5;
  border-radius: 0.3rem;
}

.btn-lg {
  padding: 0.5rem 1rem;
  font-size: 1.25rem;
  line-height: 1.5;
  border-radius: 0.3rem;
}

.px-5 {
  padding-left: 3rem !important;
  padding-right: 3rem !important;
}

.mx-2 {
  margin-left: 0.5rem !important;
  margin-right: 0.5rem !important;
}

.px-3 {
  padding-left: 1rem !important;
  padding-right: 1rem !important;
}

.py-2 {
  padding-top: 0.5rem !important;
  padding-bottom: 0.5rem !important;
}

.text-center {
  text-align: center;
}

.d-block {
  display: block;
}

.w-auto {
  width: auto !important;
}

.mx-auto {
  margin-left: auto !important;
  margin-right: auto !important;
}

.justify-content-center {
  justify-content: center !important;
}

.align-items-end {
  align-items: flex-end !important;
}

@media (max-width: 768px) {
  .fs-4 {
    font-size: 1.5rem !important;
  }
  
  .fs-5 {
    font-size: 1rem !important;
  }
  
  .form-control-lg {
    font-size: 1rem;
    min-width: 150px !important;
  }
  
  .btn-lg {
    font-size: 1rem;
    padding: 0.4rem 0.8rem;
  }
  
  .px-3 {
    margin-bottom: 1rem;
  }
}

.form-control:focus {
  border-color: #2e507a;
  box-shadow: 0 0 0 0.2rem rgba(46, 80, 122, 0.25);
}

label b {
  color: #2c3e50;
}

.container {
  width: 100%;
  padding-right: 15px;
  padding-left: 15px;
  margin-right: auto;
  margin-left: auto;
}

@media (min-width: 1200px) {
  .container {
    max-width: 1140px;
  }
}
</style>
<style src="../main.css" scoped></style>
